import React from "react";
import avatarImg from "../../assets/img/avatar.png";
// import Swiper core and required modules
import { Pagination, EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "./testimonials.css";

const testimonials = [
  {
    id: 1,
    name: "Abdelrahman Etry",
    img: avatarImg,
    review:
      "Working with George was better than expected and we had really high expectations. He is an incredibly talented developer but what really makes him stand out is his work ethic and steady approach. Time after time, and without asking, he added enhancements and improvements that resulted in a better end product.",
  },
  {
    id: 2,
    name: "Aya Magdy",
    img: avatarImg,
    review:
      "George is a goal oriented, task focused, reliable developer with a straightforward communication style . He aims to improve his skills in every way he can in his wide variety of interests. His passion for technologies and development really shows, and can inspire others.",
  },
  {
    id: 3,
    name: "Omar Ahmed",
    img: avatarImg,
    review:
      "He is easy to communicate and reach, available 24/7 when i need him. also talented person with wide range for best solutions available.",
  },
  {
    id: 4,
    name: "Upwork Client",
    img: avatarImg,
    review: "Highly recommend! very proactive and effective",
  },
  {
    id: 5,
    name: "Upwork Client",
    img: avatarImg,
    review:
      "Great front end developer. Prompt delivery and hard working person.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination, EffectFade, Autoplay]}
        spaceBetween={40}
        slidesPerView={1}
        effect="fade"
        navigation
        // autoplay={{
        //   delay: 3500,
        //   disableOnInteraction: false,
        // }}
        pagination={{ clickable: true }}
      >
        {testimonials.map((testimonial) => (
          <SwiperSlide
            className="testimonial"
            key={testimonial.name + testimonial.id}
          >
            <div className="client__avatar">
              <img
                loading="lazy"
                src={testimonial.img}
                alt={testimonial.review}
              />
            </div>
            <h5 className="client__name">{testimonial.name}</h5>
            <small className="client__review">{testimonial.review}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
